import { IPivotStyles, IRawStyle, IStyle } from '@fluentui/react';

import { IH2OTheme } from '../../models/components.models';
import { FontSizes, FontWeights, Sizes } from '../../themes/styles';

export interface IPivotContainerStyles {
  root?: IStyle;
}

export interface IPivotContainerClassNames {
  root?: string;
}

export const pivotContainerStylesDefault: Partial<IPivotContainerStyles> = {
  root: {
    '&.vertical': {
      '.ms-Pivot-wrapper': {
        display: 'flex',
      },
    },
  },
};

export const pivotContainerStylesFill: Partial<IPivotContainerStyles> = {
  root: {
    height: '100%',
    overflow: 'hidden',
    '.ms-Pivot-wrapper': {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
  },
};

const linkStyles = (theme: IH2OTheme): IRawStyle => ({
  marginRight: 0,
  height: Sizes.height,
  paddingLeft: Sizes.padding,
  paddingRight: Sizes.padding,
  '::before': {
    left: 0,
    right: 0,
    bottom: -1.4,
    backgroundColor: theme.palette?.gray300,
  },
  '& .ms-Pivot-text': {
    fontSize: FontSizes.xsmall,
    fontWeight: FontWeights.normal,
  },
});

export const pivotStylesDefault = (theme: IH2OTheme): Partial<IPivotStyles> => ({
  root: {
    border: 0,
  },
  link: {
    ...linkStyles(theme),
    color: theme.palette?.gray700,
  },
  linkIsSelected: {
    ...linkStyles(theme),
    color: theme.palette?.gray900,
    backgroundColor: theme.palette?.primary100,
    '& .ms-Pivot-text': {
      fontWeight: FontWeights.semiBold,
    },
    '::before': {
      backgroundColor: theme.palette?.primary500,
    },
    ':hover': {
      backgroundColor: theme.palette?.primary100,
    },
  },
  linkContent: {
    lineHeight: Sizes.height,
  },
});

export const pivotStylesVertical: Partial<IPivotStyles> = {
  root: { display: 'block' },
  link: {
    '::before': {
      left: 0,
      right: 'auto',
      bottom: 'auto',
      height: '100%',
      width: 2,
    },
    display: 'block',
  },
  linkIsSelected: {
    '::before': {
      left: 0,
      right: 'auto',
      bottom: 'auto',
      height: '100%',
      width: 2,
    },
  },
  itemContainer: {
    flex: 1,
  },
};

export const pivotStylesFill: Partial<IPivotStyles> = {
  itemContainer: {
    flex: 1,
    overflow: 'hidden',
    '> div': {
      height: '100%',
    },
  },
};

export const pivotStylesSecondary = (theme: IH2OTheme): Partial<IPivotStyles> => ({
  link: {
    color: theme.palette?.gray500,
    backgroundColor: theme.palette?.white,
    '::before': {
      display: 'none',
    },
  },
  linkIsSelected: {
    backgroundColor: theme.palette?.primary500,
    color: theme.palette?.textOverPrimary,
    '::before': {
      display: 'none',
    },
    ':hover': {
      backgroundColor: theme.palette?.primary500,
      color: theme.palette?.textOverPrimary,
    },
  },
});
